"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    //simple
    {
        type: 'textfield',
        inputType: 'url',
        key: 'aricallselect',
        input: true,
        weight: 5,
        label: 'API for search by key input',
        tooltip: 'API for search by key input.',
        placeholder: 'bo/bank/list',
        defaultValue: '',
        conditional: {},
    },
    //simple
    {
        type: 'datagrid',
        key: 'aribody',
        input: true,
        weight: 6,
        label: 'Request message body',
        addAnother: 'Add Node',
        tooltip: 'JSON body message structure',
        components: [
            {
                key: 'path',
                label: 'Path',
                input: true,
                type: 'textfield',
            },
            {
                type: 'select',
                key: 'type',
                label: 'Type',
                input: true,
                dataSrc: 'values',
                data: {
                    values: [
                        { label: 'Value', value: 'value' },
                        { label: 'Data', value: 'data' },
                        { label: 'Script', value: 'script' },
                    ],
                },
                defaultValue: 'data'
            },
            {
                key: 'value',
                label: 'Value',
                input: true,
                //rows: 3,
                //editor: 'ace',
                as: 'javascript',
                type: 'textarea',
                attributes: {
                    style: 'height:calc(1.5em + .75rem + 2px)',
                },
                placeholder: '',
            }
        ],
        conditional: {
            json: { '===': [{ var: 'data.dataSrc' }, 'aripost'] },
        },
    },
    {
        type: 'textfield',
        label: 'Value for search',
        key: 'keyForSearch',
        input: true,
        weight: 7,
        tooltip: 'Key needs to be transmitted for searching',
        placeholder: 'param.userName',
        conditional: {}
    },
    {
        type: 'textfield',
        label: 'Key id',
        key: 'KeyId',
        input: true,
        weight: 7,
        tooltip: 'Key id for reset',
        placeholder: 'param.id',
        conditional: {}
    },
    {
        type: 'textfield',
        input: true,
        key: 'idPath',
        weight: 12,
        label: 'ID Path',
        placeholder: 'id',
        tooltip: 'Path to the select option id.'
    },
    {
        type: 'textarea',
        input: true,
        key: 'template',
        label: 'Item Template',
        editor: 'ace',
        as: 'html',
        rows: 3,
        weight: 18,
        tooltip: 'The HTML template for the result data items',
        placeholder: 'Like another select but no need {item.value} just {value}'
    },
];
